module.exports = __webpack_public_path__ + "static/media/Pirate600_4c.85bcc480.svg";